"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/tree-select/interface.tsx
 ** module id = 641
 ** module chunks = 0 1
 **/